/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button} from "antd";
import styles from './ModooCarListFilters.module.scss';
import MultiSelect from "../../../components/common/selector/MultiSelect";

interface CarListFilterProps {
	locations: string[];
	carTypes: string[];
	onSelectLocation: (location: string[]) => any;
	onSelectCarType: (carType: string[]) => any;
	onSearch: () => any;
	onClear: () => any;
}

const ModooCarListFilters = ({ locations, carTypes, onSelectLocation, onSelectCarType, onSearch, onClear }: CarListFilterProps) => {
	const locationOptions = [
		{ label: '서울', value: '서울', color: 'blue' },
		{ label: '경기', value: '경기', color: 'blue' },
		{ label: '인천', value: '인천', color: 'blue' },
		{ label: '강원', value: '강원', color: 'purple' },
		{ label: '충북', value: '충북', color: 'cyan' },
		{ label: '충남', value: '충남', color: 'cyan' },
		{ label: '세종', value: '세종', color: 'cyan' },
		{ label: '대전', value: '대전', color: 'cyan' },
		{ label: '전북', value: '전북', color: 'green' },
		{ label: '전남', value: '전남', color: 'green' },
		{ label: '광주', value: '광주', color: 'green' },
		{ label: '경북', value: '경북', color: 'magenta' },
		{ label: '대구', value: '대구', color: 'magenta' },
		{ label: '경남', value: '경남', color: 'red' },
		{ label: '울산', value: '울산', color: 'red' },
		{ label: '부산', value: '부산', color: 'red' },
		{ label: '제주', value: '제주', color: 'orange' },
	];

	const carTypeOptions = ['1t', '2t', '3t', '5t', '54m', '58m', '75m', '28m', '40m', '60m', '70m']
		.map((item) => {
			if (['28m', '40m', '60m', '70m'].includes(item)) return { label: `${item}(굴절)`, value: item };
			return { label: item, value: item } ;
		});

	return (
		<div className={styles.wrap}>
			{/* 지역 필터 */}
			<div className={styles.locationWrap}>
				<MultiSelect
					value={locations}
					options={locationOptions}
					placeholder="지역 필터"
					onChange={onSelectLocation}
				/>
			</div>

			{/* 톤수 필터 */}
			<div className={styles.carTypeWrap}>
				<MultiSelect
					value={carTypes}
					options={carTypeOptions}
					placeholder="차량 톤수 필터"
					onChange={onSelectCarType}
				/>
			</div>

			<div>
				<Button type="primary" onClick={onSearch}>검색</Button>
			</div>

			<div>
				<Button onClick={onClear}>초기화</Button>
			</div>
		</div>
	);
};

export default ModooCarListFilters;
